import Close from '../../assets/svg/close.svg';
import Error from '../../assets/svg/error.svg';
import Info from '../../assets/svg/info.svg';
import Warning from '../../assets/svg/warning.svg';

import React from 'react';
import './Alert.css';
import {useTranslation} from 'react-i18next';

const AlertWidget = (props) => {
  const [isVisible, setIsVisible] = React.useState(true);
  const {t} = useTranslation();
  const ICON_ENUM = {
    error: <img src={Error} alt="Error" />,
    warning: <img src={Warning} alt="Warning" />,
    info: <img src={Info} alt="Info" />,
  };
  return (
    <>
      {isVisible ? (
        <div className="alert-wrapper" id={props.type}>
          <div className="alert-body">
            <div className="alert-icon">{ICON_ENUM[props.type]}</div>
            <div className="alert-content">{t(props.content)}</div>
          </div>
          {props.isClosable ? (
            <div
              className="alert-close"
              data-testid="alert-close"
              onClick={() => setIsVisible(false)}
            >
              <img src={Close} alt="Close" />
            </div>
          ) : (
            ''
          )}
        </div>
      ) : (
        ''
      )}
    </>
  );
};

export default AlertWidget;
